
angular.module('admin')
.controller('AdminController', ['$scope', '$state', 'Auth', 'USER_ROLES',
    function ($scope, $state, Auth, USER_ROLES) {
        // Only redirect to default tab if we're on the bare parent state
        if ($state.current.name === 'admin') {
            console.log('redirecting to admin.practice');
            $state.go('admin.practice')
        }
        $scope.tabsData = [
            {
                heading: 'Practice',
                route: 'admin.practice',
                class: 'fas fa-building',
            },
            {
                heading: 'Users',
                route: 'admin.users',
                class: 'fas fa-users',
            },
            {
                heading: 'Colleagues',
                route: 'admin.invite',
                class: 'fas fa-user-plus',
            },
            {
                heading: 'Support',
                route: 'admin.support',
                class: 'fas fa-user',
            },
        ];

        var currentYear = moment().year();
        $scope.years = [currentYear, currentYear + 1, currentYear + 2, currentYear + 3, currentYear + 4];

        $scope.auth = Auth.get() || {};
        $scope.auth.is_admin = Auth.hasRole(USER_ROLES.admin);

        $scope.activeTabIndex = $scope.tabsData.findIndex(tab => $state.includes(tab.route));
    }]);